import {
  IProduct,
  IProductPhase,
  IActivity,
  IForm,
  IFormField,
  ISubprocessGenerator,
} from "./types";

export const mapProductToDTO = (product: IProduct): IProduct => ({
  ...product,
  phases: product.phases.map(mapPhaseToDTO),
  financialConfig: product.financialConfig,
});

const mapPhaseToDTO = (phase: IProductPhase): IProductPhase => ({
  ...phase,
  activities: phase.activities?.map(mapActivityToDTO) || [],
  subprocessGenerators:
    phase.subprocessGenerators?.map(mapSubprocessGeneratorToDTO) || [],
  financialConfig: phase.financialConfig,
});

const mapActivityToDTO = (activity: IActivity): IActivity => ({
  ...activity,
  form: activity.form ? mapFormToDTO(activity.form) : undefined,
  financialConfig: activity.financialConfig,
});

const mapFormToDTO = (form: IForm): IForm => ({
  ...form,
  fields: form.fields.map(mapFormFieldToDTO),
  financialConfig: form.financialConfig,
});

const mapFormFieldToDTO = (field: IFormField): IFormField => ({
  ...field,
});

const mapSubprocessGeneratorToDTO = (
  generator: ISubprocessGenerator,
): ISubprocessGenerator => ({
  ...generator,
  financialConfig: generator.financialConfig,
});

export const productMapper = {
  toDTO: mapProductToDTO,
  phaseToDTO: mapPhaseToDTO,
  activityToDTO: mapActivityToDTO,
  formToDTO: mapFormToDTO,
  formFieldToDTO: mapFormFieldToDTO,
  subprocessGeneratorToDTO: mapSubprocessGeneratorToDTO,
};
